import { FlightDesignatorModel } from "../../booking/models/designator/flight-designator.model";
import {IDotRezAvailableSegment} from "../../dot-rez-api/data-contracts/booking/search-simple/search-simple.data-contracts";
import { IServiceFactory } from "../../service-factory.interface";
import {AvailabilityLegModel} from "./availability-leg.model";
import {IAvailableSegmentViewModel} from "./available-segment-view-model.interface";
import {FlightIdentifierModel} from "../../booking/models/identifier/flight-identifier.model";
import {IBookingStrategy} from "../../booking/booking-strategies/booking-strategy.interface";

/**
 * A segment is a part from a journey that has multiple connections
 */
export class AvailableSegmentModel implements IAvailableSegmentViewModel {
    constructor(private readonly bookingStrategy: IBookingStrategy,
                private readonly segmentData: IDotRezAvailableSegment) {
        this.legs = segmentData.legs.map(leg => new AvailabilityLegModel(bookingStrategy, leg, segmentData));
    }

    get key(): string {
        return this.segmentData.segmentKey;
    }

    get originStation(): string {
        return this.segmentData.designator.origin;
    }

    get destinationStation(): string {
        return this.segmentData.designator.destination;
    }

    get services(): IServiceFactory {
        return this.bookingStrategy.services;
    }


    get identifier(): FlightIdentifierModel{
        return new FlightIdentifierModel(
            this.segmentData.identifier.carrierCode,
            this.segmentData.identifier.identifier,
            null,
            this.services
        );
    }

    get isDomesticFlight(): boolean {
        return !this.segmentData.international;
    }

    get designator(): FlightDesignatorModel {
        const legs = this.segmentData.legs;
        return new FlightDesignatorModel(
            this.services,
            this.services.stations.getStation(this.segmentData.designator.origin),
            this.services.stations.getStation(this.segmentData.designator.destination),
            this.segmentData.designator.departure,
            this.segmentData.designator.arrival,
            legs[0].legInfo.departureTimeUtc,
            legs[legs.length - 1].legInfo.arrivalTimeUtc,
            this.legs.map(l => l.designator),
            this.identifier);
    }

    readonly legs: AvailabilityLegModel[];

}
